import { render, staticRenderFns } from "./OrderCustomerSignature.vue?vue&type=template&id=2e5c84a9&scoped=true"
import script from "./OrderCustomerSignature.vue?vue&type=script&lang=js"
export * from "./OrderCustomerSignature.vue?vue&type=script&lang=js"
import style0 from "./OrderCustomerSignature.vue?vue&type=style&index=0&id=2e5c84a9&prod&lang=scss"
import style1 from "./OrderCustomerSignature.vue?vue&type=style&index=1&id=2e5c84a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5c84a9",
  null
  
)

export default component.exports